import moment from 'moment'
import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Credit } from '../../types'
import ActionTypes from './actionTypes'
import { ArrayUtils, ObjectUtils } from '../../utils'

type CreditUpdateRequest = {
    type: typeof ActionTypes.CREDIT_UPDATE_REQUEST;
    payload: never;
}

type CreditUpdateFailure = {
    type: typeof ActionTypes.CREDIT_UPDATE_FAILURE;
    payload: Error;
}

type CreditUpdateSuccess = {
    type: typeof ActionTypes.CREDIT_UPDATE_SUCCESS;
    payload: Credit;
}

const UpdateCreditFields = [
    'type',
    'start_date',
    'end_date',
    'skus',
] as const

/**
 * Update one credit given its ID
 */
function updateCredit(credit: Credit) {
    const body = ObjectUtils.copy(credit, UpdateCreditFields, {
        start_date: (v: Date) => moment(v).format('YYYY-MM-DD'),
        end_date: (v: Date) => moment(v).format('YYYY-MM-DD'),
        skus: ArrayUtils.cleanStringArray,
    })

    return createAction<RootState, Credit, never>({
        endpoint: `${HUBBLE_API_TOKEN}/credits/${credit.id}`,
        method: 'PUT',
        body: JSON.stringify(body),
        types: [
            ActionTypes.CREDIT_UPDATE_REQUEST,
            ActionTypes.CREDIT_UPDATE_SUCCESS,
            ActionTypes.CREDIT_UPDATE_FAILURE,
        ],
    })
}

export type CreditUpdateAction = CreditUpdateRequest
    | CreditUpdateFailure
    | CreditUpdateSuccess

export default updateCredit
